import * as React from 'react';

import {CalendarWrapper} from 'shells/calendar/calendar-wrapper';
import {Popover} from 'shells/popover/popover';

type Props = {
    // @ts-expect-error
    initialDate: moment.Moment;
    // @ts-expect-error
    onSubmit: (arg1: moment.Moment) => void;
    onCancel: () => void;
    isLightMode?: boolean;
    shouldDisableFocusTrapZone?: boolean;
    onKeyDown?: (event: KeyboardEvent) => void;
};

export function DatePicker(props: Props) {
    const {shouldDisableFocusTrapZone = true} = props;

    // @ts-expect-error
    const [displayDate, setDisplayDate] = React.useState<moment.Moment>(props.initialDate);

    // @ts-expect-error
    const handleSubmit = (date: moment.Moment) => {
        setDisplayDate(date);
        props.onSubmit(date);
    };

    return (
        // @ts-expect-error
        <Popover
            {...props}
            isNubDark={!props.isLightMode}
            onBlur={props.onCancel}
            onKeyDown={props.onKeyDown}
            disableFocusTrapZone={shouldDisableFocusTrapZone}
        >
            <div style={{width: 238}}>
                <CalendarWrapper
                    momentDisplayDate={displayDate}
                    onDateClick={handleSubmit}
                    isLightMode={props.isLightMode}
                />
            </div>
        </Popover>
    );
}
